<!--
 * @Author: M.D.
 * @Date: 2019-12-23 14:25:25
 * @LastEditors  : M.D.
 * @Description: 商品评价
 * @Remarks:
 -->
<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="20" :offset="2">
        <div class="box">
          <div class="sub-result-box">
            <div v-show="Number(this.payState)===1" class="pay-box">
              <div class="left-icon">
                <img src="@/assets/image/pay_success.png">
              </div>
              <div class="right-txt">
                <p class="order-state">订单已提交</p>
                <p class="order-tip">{{ tip }}</p>
              </div>
              <div class="pay-btn">
                <el-button style="height: 36px" v-if="showQrcode" type="success" @click.stop="queryQrCode()">查看二维码</el-button>
                <el-button style="margin-left: 70px" @click="goToOrderPage" type="text">我的订单>></el-button>
              </div>
            </div>
            <div v-show="this.payState===0" class="pay-box">
              <div class="left-icon">
                <img src="@/assets/image/pay_error.png">
              </div>
              <div class="right-txt">
                <p class="order-state">支付失败</p>
                <p class="order-tip">{{ erMsg }}</p>
              </div>
              <div class="pay-btn">
                <el-button style="height: 36px" @click="back" type="success">返回重试</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <od-qrcode-dialog :selectedOrder="order" :show="qrDialogShow" @qrcodeDialogClose="qrcodeDialogClose"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OdQrcodeDialog from '@/components/od-qrcode-dialog'

export default {
  props: {},
  data () {
    return {
      payState: 0, // 0支付失败  1支付成功,
      orderNumber: '',
      goodsName: '',
      qrDialogShow: false,
      qr: '',
      tip: '我们将在24小时内电话联系您，请耐心等待~',
      erMsg: '抱歉，订单提交失败，请检查网络设置是否连接'
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    order () {
      return {
        orderNumber: this.orderNumber,
        goodsName: this.goodsName,
        qr: this.qr
      }
    },
    showQrcode () {
      return this.qr && this.qr !== ''
    }
  },
  created () {
    this.payState = this.$route.query.payState
    this.orderNumber = this.$route.query.orderNumber
    this.goodsName = this.$route.query.goodsName
    this.qr = this.$route.query.qr
    this.tip = this.$route.query.tip || '我们将在24小时内电话联系您，请耐心等待~'
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {

  },
  watch: {},
  methods: {
    queryQrCode () {
      if (Number(this.payState) === 1) {
        this.qrDialogShow = true
      }
    },
    qrcodeDialogClose (v) {
      this.qrDialogShow = v
    },
    goToOrderPage () {
      this.$router.push({ name: 'orders', params: { } })
    },
    back () {
      this.$router.go(-1)
    }
  },
  components: {
    OdQrcodeDialog
  }
}
</script>

<style lang="stylus">
  .box
    float: left
    background-color: white
    margin-top 20px
    margin-bottom 20px
    width: 100%
    .sub-result-box
      background-color white
      margin: 0 auto;
      width 40%

      .pay-box
        padding-top 30px
        padding-bottom 30px
        float left
        margin: 0 auto;
        width auto

        .left-icon
          float left
          height 100%
          text-align right

        .right-txt
          float: left
          text-align left

          .order-state
            color: #31A826
            font-size 15px

          .order-tip
            color #808080
            font-size 12px

        .pay-btn
          float: left
          margin-top 30px
</style>
